import { ActionIcon, Button, Group, Input, Navbar, ScrollArea, Switch, Tooltip } from '@mantine/core';
import { useForm } from '@mantine/form';
import { IconBooks, IconVariable, IconX, IconMessage } from '@tabler/icons';
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { LinksGroup } from '../../components/NavbarLinksGroup/NavbarLinksGroup';
import { ScriptContext } from "../context/ScriptContext";
import { mockdata } from './menuData';
import './navbar.css';
import { useStyles } from './style';
import { AppSettingsContext } from '../context/AppSettingsContext';
import ModalCustomNode from '../ModalCustomNode';
import { compareAppVersions } from '../../compareAppVersions';
import Chat from '../Chat';

const NavbarNested = (props) => {
    const text = useRef('')
    const ref = useRef(null)
    const { settings } = useContext(AppSettingsContext)
    const scriptContext = useContext(ScriptContext);
    const { classes } = useStyles();
    const customNodeRef = useRef(null);
    const [navItem, setNavItem] = useState(mockdata.map(item => ({ ...item, links: item.links.filter(link => link.data.version <= settings.autoVersion) })));
    const [show, setShow] = useState(false)
    const [filter, setFilter] = useState({ search: '', page: 1, limit: 9 });
    const [lastPage, setLastPage] = useState(1);
    const [category, setCategory] = useState('-1')
    const [chatMode, setChatMode] = useState(true)
    const handleOpenNode = (index) => {
        const newState = [...navItem]
        newState[index].initiallyOpened = !newState[index].initiallyOpened
        setNavItem(newState)
    }

    useEffect(() => {
        setNavItem(mockdata.map(item => ({ ...item, links: item.links.filter(link => {
            console.log(link.data.appVersion);
            if (link.data.appVersion) {
                const appVersion = window.api?.APP_VERSION || localStorage.getItem('appVersion') || ''
                return compareAppVersions(appVersion, link.data.appVersion) >= 0
            }
            return link.data.version <= settings.autoVersion
        }) })))
    },[settings.autoVersion])

    const links = useMemo(
        () => navItem.map(
            (item, index) => <LinksGroup {...item}
                key={item.label}
                index={index}
                handleOpenNode={handleOpenNode}
                handleDbClick={props.handleDbClick}
            />
    ), [navItem]);
    const form = useForm({
        initialValues: { name: scriptContext.scriptName ?? '' },

        // functions will be used to validate values at corresponding key
        validate: {
            name: (value) => (value.length < 1
                ? 'Name must have at least 1 letters'
                : value.length > 255
                    ? 'Name is too long'
                    : null
            ),
        },
    });

    useEffect(() => {
        form.setValues({
            name: scriptContext.scriptName ?? "",
        })
    }, [scriptContext])

    const handleOpenAllNodes = (event) => {
        const isChecked = event.target.checked;

        const newData = navItem.map(item => ({
            ...item,
            initiallyOpened: isChecked
        }));

        if (customNodeRef.current) {
            customNodeRef.current.setOpenCollapse(isChecked);
        }

        setNavItem(newData);
    };


   const handleClearInput = () => {
        text.current.value = ""
        setNavItem(mockdata.map(item => ({ ...item, links: item.links.filter(link => link.data.version <= settings.autoVersion) })))
   }

   const rightSection = (<ActionIcon onClick={handleClearInput} radius="xl"><IconX size="1rem"/></ActionIcon>)

   const handleFilter = (e) => {
        const text = e.target.value
        const newData = [...mockdata].map(item => ({
            ...item,
            links: item.links.filter(link => {
                console.log(link.data.appVersion);
                if (link.data.appVersion) {
                    const appVersion = window.api?.APP_VERSION || localStorage.getItem('appVersion') || ''
                    return compareAppVersions(appVersion, link.data.appVersion) >= 0
                }
                return link.data.version <= settings.autoVersion
            })
        }))
        let node = newData.map((element) => {
            if (text.toLowerCase() === "") {
                return element
            } else {
                return {...element, links: element.links.filter((nodeLink) =>
                    nodeLink.data.label.toLowerCase().includes(text.toLowerCase())
                )}
            }
        })
        setNavItem(node)
   }

    return (
        <>
            <Navbar width={{ sm: 360 }} p="md" className={classes.navbar}>
                <Navbar.Section className={classes.header}>
                    <Group style={{ justifyContent: 'center' }}>
                        {
                            chatMode ? (
                                <>
                                <Tooltip label='Select nodes manually'>
                                    <Button
                                        variant='default'
                                        onClick={() => setChatMode(!chatMode)}
                                    >
                                        Manual
                                    </Button>
                                </Tooltip>
                                </>
                            ) : (
                                <>
                                    <Input
                                        ref={text}
                                        placeholder="Search"
                                        style={{ width: 190 }}
                                        rightSection={rightSection}
                                        onChange={handleFilter}
                                    />
                                    <Switch
                                        size='sm'
                                        className='d-flex'
                                        ref={ref}
                                        checked={navItem.some((item) => item.initiallyOpened)}
                                        onChange={handleOpenAllNodes}
                                        style={{
                                            opacity: chatMode ? 0 : 1,
                                            pointerEvents: chatMode ? 'none' : 'auto',
                                            transition: 'opacity 0.3s ease' // hiệu ứng mượt
                                        }}
                                        />
                                    <Tooltip label='Generate script with AI'>
                                        <Button
                                            variant={chatMode ? 'filled' : 'default'}
                                            onClick={() => setChatMode(!chatMode)}
                                        >
                                            <IconMessage/>
                                        </Button>
                                    </Tooltip>
                                </>
                            )
                        }
                    </Group>
                    {
                        !chatMode && (
                            <div style={{ marginTop: '20px'}}>
                                <Group position="apart" align="center">
                                    <Button
                                        leftIcon={<IconVariable size={14} />}
                                        variant="default"
                                        onClick={props.handleShowVariables}
                                    >
                                        Variables
                                    </Button>
                                    <Button
                                        leftIcon={<IconBooks stroke={1.25} size={14}/>}
                                        variant="default"
                                        onClick={() => setShow(true)}
                                    >
                                        Library custom node
                                    </Button>
                                </Group>
                            </div>
                        )
                    }
                </Navbar.Section>
                <Navbar.Section grow className={classes.links} component={ScrollArea}>
                    {
                        chatMode ? (
                            <Chat/>
                        ) : (
                            <div className={classes.linksInner}>
                                {links}
                            </div>
                        )
                    }
                </Navbar.Section>
                <Navbar.Section className={classes.footer}>
                </Navbar.Section>
            </Navbar>
            {show && <ModalCustomNode
                show={show}
                setShow={setShow}
                props={props}
                filter={filter}
                setFilter={setFilter}
                lastPage={lastPage}
                setLastPage={setLastPage}
                category={category}
                setCategory={setCategory}
            />}
        </>
    );
}

export default NavbarNested;